import React from "react";
import { Button, Tooltip } from "@mantine/core";
import { appStore } from "@/app/store/appStore";
import { getRedirect, openLink, rememberLocationForPostOauth } from "@shared/utils/helpers";
import { IconBrandGoogle } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { persistStore } from "@entities/StepFolder/store/persistStore";

const GoogleOAuthButton: React.FC = () => {
	const { t } = useTranslation();
	const isPrivacy = persistStore(state => state.isPrivacy);

	const clientId = appStore((state) => state.gameConfig.PublicWebClientConfig.Auth?.Google?.ClientId);

	const generateNonce = () => {
		return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
	};
	const initiateLogin = () => {
		const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}.apps.googleusercontent.com&redirect_uri=${getRedirect("google")}&response_type=id_token&scope=openid%20profile%20email&nonce=${generateNonce()}`;
		rememberLocationForPostOauth();
		openLink(authUrl);
	};

	return (
		clientId && (
			<Button disabled={!isPrivacy} variant={"box"} onClick={initiateLogin}>
				<Tooltip label={t("common.LoginWithGoogle", "Login with Google")}>
					<IconBrandGoogle></IconBrandGoogle>
				</Tooltip>
			</Button>
		)
	);
};

export default GoogleOAuthButton;
